/* eslint-disable no-unused-vars */
import React, { useRef, useMemo, useEffect } from 'react'
import * as yup from 'yup'

import { FormButtons, Form, TextInput } from '@/components'
import { getMaskedString } from '@/utils'
import { ICustomer } from '@/types'
import { useForm } from '@/hooks'
import { t } from '@/i18n'

interface Props {
  loading: boolean
  details: any[]
  isEditing?: boolean
  submitting: boolean
  onCancel: () => void
  initialData?: Partial<ICustomer>
  onSubmit: (d: ICustomer) => void
}

const EditCustomerForm: React.FC<Props> = ({
  details,
  loading,
  onCancel,
  onSubmit,
  isEditing,
  submitting,
  initialData,
}) => {
  const schema: any = useMemo(
    () =>
      yup
        .object({
          name: yup.string().required(t('required_field_error')),
          type: yup.string().required(t('required_field_error')),
        })
        .required(),
    [],
  )

  const { control, isValid, onTriggerChange, onFormSubmit } = useForm<any>({
    isEditing,
    defaultValues: initialData,
    schema,
    onSubmit,
  })

  const formRef = useRef<HTMLFormElement | null>(null)

  useEffect(() => {
    if (initialData?.phone) {
      onTriggerChange('phone', getMaskedString(initialData.phone, true))
    }
  }, [onTriggerChange, initialData?.phone])

  useEffect(() => {
    if (initialData?.bank) {
      onTriggerChange('bank', initialData.bank.id)
    }
  }, [initialData?.bank, onTriggerChange])

  const emptyValue = useMemo(() => (isEditing ? '' : '...'), [isEditing])

  return (
    <Form<ICustomer>
      formRef={formRef}
      control={control}
      isEditing={isEditing}
      onSubmit={onFormSubmit}
    >
      <div className="info-box no-border w-100">
        <div className="main-info">
          <div className="data-box no-border">
            <h3>{t('edit_customer_label', { label: 'TODO' })}</h3>
            <div className="form-fields">
              {details.map(input => (
                <TextInput
                  {...input}
                  key={input.name}
                  control={control}
                  label={t(input.label)}
                  emptyValue={emptyValue}
                  disabled={!Boolean(isEditing)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <FormButtons
        formRef={formRef}
        visible={isEditing}
        onCancel={onCancel}
        isFormValid={isValid}
        submitting={submitting}
      />
    </Form>
  )
}

export default EditCustomerForm
